document.addEventListener('DOMContentLoaded', () => {
  const gate = document.getElementById('ac-agegate');
  if (!gate) return;

  const confirmButton = gate.querySelector('[data-age-gate-confirm]');
  const leaveButton = gate.querySelector('[data-age-gate-leave]');
  const storageKey = 'acAgeVerified';
  let inertRegions = [];

  const hasConfirmedAge = () => {
    try {
      return window.localStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const setPageInert = (isInert) => {
    if (isInert) {
      inertRegions = Array.from(document.body.children).filter(
        (element) => element !== gate && !['SCRIPT', 'STYLE'].includes(element.tagName)
      );
    }

    inertRegions.forEach((element) => {
      element.inert = isInert;
    });
  };

  const openGate = () => {
    gate.hidden = false;
    gate.setAttribute('aria-hidden', 'false');
    document.body.classList.add('age-gate-open');
    setPageInert(true);
    window.requestAnimationFrame(() => confirmButton?.focus());
  };

  const closeGate = () => {
    gate.hidden = true;
    gate.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('age-gate-open');
    setPageInert(false);
  };

  confirmButton?.addEventListener('click', () => {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {
      // The current visit can continue even if storage is unavailable.
    }
    closeGate();
  });

  leaveButton?.addEventListener('click', () => {
    window.location.replace('https://www.google.com');
  });

  gate.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      confirmButton?.focus();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = [confirmButton, leaveButton].filter(Boolean);
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  if (!hasConfirmedAge()) openGate();
});
